import { getBrandfolderWithGenericFileSections } from '../services/brandfolder';
import {
  removeApiKey as removeApiKeyInLocalStorage,
  setApiKey as setApiKeyInLocalStorage
} from '../services/localStorage';

export const LOADING_BRANDFOLDER = 'LOADING_BRANDFOLDER';
export const LOAD_BRANDFOLDERS = 'LOAD_BRANDFOLDERS';
export const LOAD_BRANDFOLDER_WITH_GENERIC_SECTIONS = 'LOAD_BRANDFOLDER_WITH_GENERIC_SECTIONS';
export const REMOVE_API_KEY = 'REMOVE_API_KEY';
export const SET_API_KEY = 'SET_API_KEY';
export const SET_SELECTED_BRANDFOLDER_ID = 'SET_SELECTED_BRANDFOLDER_ID';

export const loadingBrandfolder = loading => ({
  type: LOADING_BRANDFOLDER,
  loading
});

export const loadBrandfolderWithGenericFileSections = brandfolder => dispatch => {
  dispatch(loadingBrandfolder(true));
  getBrandfolderWithGenericFileSections(brandfolder.id).then(brandfolderWithGenericFileSections =>
    dispatch({
      type: LOAD_BRANDFOLDER_WITH_GENERIC_SECTIONS,
      brandfolderWithGenericFileSections
    })
  );
};

export const removeApiKey = () => dispatch => {
  removeApiKeyInLocalStorage();
  dispatch({
    type: REMOVE_API_KEY
  });
};

export const setApiKey = apiKey => dispatch => {
  setApiKeyInLocalStorage(apiKey);
  dispatch({
    type: SET_API_KEY,
    apiKey
  });
};

export const setSelectedBrandfolderId = brandfolderId => ({
  type: SET_SELECTED_BRANDFOLDER_ID,
  brandfolderId: brandfolderId
});



// WEBPACK FOOTER //
// ./src/actions/brandfolder.js